import React, { createContext, useContext, useState, useEffect } from 'react';

const AccessContext = createContext(null);

export const useAccess = () => {
  const context = useContext(AccessContext);
  if (!context) {
    throw new Error('useAccess must be used within an AccessProvider');
  }
  return context;
};

export const AccessProvider = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [memberEmail, setMemberEmail] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Check localStorage for existing access
    const storedAccess = localStorage.getItem('secret13_access');
    const storedEmail = localStorage.getItem('secret13_email');
    
    if (storedAccess === 'granted' && storedEmail) {
      setHasAccess(true);
      setMemberEmail(storedEmail);
    }
    setIsLoading(false);
  }, []);

  const grantAccess = (email) => {
    setHasAccess(true);
    setMemberEmail(email);
    localStorage.setItem('secret13_access', 'granted');
    localStorage.setItem('secret13_email', email);
  };

  const revokeAccess = () => {
    setHasAccess(false);
    setMemberEmail('');
    localStorage.removeItem('secret13_access');
    localStorage.removeItem('secret13_email');
  };

  return (
    <AccessContext.Provider value={{ hasAccess, memberEmail, grantAccess, revokeAccess, isLoading }}>
      {children}
    </AccessContext.Provider>
  );
};
